import { styled } from '@mui/material/styles';

interface IconProps {
	variant: 'midGrey' | 'main' | 'disabled';
	large: boolean;
}

export const NewRoot = styled('div')(() => ({
	alignSelf: 'start',
	display: 'grid',
	gridAutoFlow: 'column',
	gridTemplateRows: 'max-content',
	gridAutoColumns: 'max-content',
}));

export const SymbolCircleV2 = styled('div', {
	shouldForwardProp: (prop) => prop !== 'backgroundColor' && prop !== 'large',
})<IconProps>(({ theme, variant, large }) => ({
	display: 'grid',
	placeContent: 'center',
	width: large ? 48 : 30,
	height: large ? 48 : 30,
	borderRadius: '50%',
	border: `1px solid ${theme.palette.neutral[0]}`,
	color: theme.palette.primary.main,

	...(variant === 'main' && {
		background: theme.palette.secondary.main,
	}),

	...(variant === 'midGrey' && {
		background: theme.palette.neutral[40],
	}),

	...(variant === 'disabled' && {
		background: theme.palette.neutral[0],
		color: theme.palette.neutral[80],
	}),
}));

export const SeparatorCircle = styled('div')(({ theme }) => ({
	backgroundColor: theme.palette.primary.main,
	borderRadius: '50%',
	width: '3px',
	height: '3px',
	margin: '0 3px',
	alignSelf: 'center',
}));
